module.exports = __webpack_public_path__ + "static/img/home_remark_01.693af4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_remark_01.png
// module id = IYoK
// module chunks = 1